import { Box, Container, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { makePostRequest } from 'utils/api'
import logo from '../../Components/images/logo.png'
import { LoadingButton } from '@mui/lab'

export default function ResetPassword() {
  let navigate = useNavigate()
  let params = useParams()
  const [loading, setLoading] = React.useState(false)
  const [notMatch, setNotMatch] = React.useState(false)
  const [upassword, setUpassword] = React.useState({
    newPassword: '',
    confirmPassword: '',
  })

  const handleSubmit = async (event) => {
    setLoading(true)
    event.preventDefault()
    const data = new FormData(event.currentTarget)
    const payload = {
      password: data.get('np'),
      code: params.code,
    }
    if (data.get('np') !== data.get('cp')) {
      setLoading(false)
      return
    }

    const response = await makePostRequest('/api/user/reset-password/', payload, {}, false)
    if (response.status === 200) {
      navigate('/login')
    }
  }
  const checkMatch = (e) => {
    let pass = e.target.value
    if (e.target.name === 'np' && pass) {
      if (pass === upassword.confirmPassword) {
        setNotMatch(false)
      } else {
        setNotMatch(true)
      }
    }
    if (e.target.name === 'cp' && pass) {
      if (pass === upassword.newPassword) {
        setNotMatch(false)
      } else {
        setNotMatch(true)
      }
    }
  }
  return (
    // <ThemeProvider theme={defaultTheme}>
    <Container component="main" maxWidth="xs">
      {/* <CssBaseline /> */}

      <Box
        sx={{
          pt: 15,
          pb: 30,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          color: 'white',
          width: '100%',
        }}
      >
        {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar> */}
        <Box sx={{ mb: 5 }}>
          <img src={logo} alt="" />{' '}
        </Box>

        <Box
          display={'flex'}
          justifyContent={'center'}
          flexDirection={'column'}
          alignItems={'center'}
          mt={4}
          width={'100%'}
        >
          <Typography
            component="p"
            variant="p"
            sx={{ color: 'white', fontSize: 19, fontWeight: 700 }}
          >
            Réinitialisation du mot de passe
          </Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3, width: '100%' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="np"
                  label="NouveauMot de passe"
                  type="password"
                  id="password"
                  autoComplete="n-password"
                  size="small"
                  variant="standard"
                  sx={{
                    '.MuiInputLabel-root.Mui-focused': { color: 'white' },
                    '.MuiFormLabel-root': { color: 'black', zIndex: '1', paddingX: '5px' },
                    '.MuiInputBase-input': { background: 'white', paddingX: '5px' },
                  }}
                  onChange={(e) => {
                    setUpassword((pre) => ({ ...pre, newPassword: e.target.value }))
                    checkMatch(e)
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="cp"
                  label="Confirmer nouveau mot de passe"
                  type="password"
                  id="cpassword"
                  autoComplete="n1-password"
                  size="small"
                  variant="standard"
                  sx={{
                    '.MuiInputLabel-root.Mui-focused': { color: 'white' },
                    '.MuiFormLabel-root': { color: 'black', zIndex: '1', paddingX: '5px' },
                    '.MuiInputBase-input': { background: 'white', paddingX: '5px' },
                  }}
                  onChange={(e) => {
                    setUpassword((pre) => ({ ...pre, confirmPassword: e.target.value }))
                    checkMatch(e)
                  }}
                />
              </Grid>
            </Grid>
            {notMatch && (
              <Box component={'p'} color={'red'}>
                le mot de passe ne correspond pas
              </Box>
            )}

            <LoadingButton
              loading={loading}
              loadingPosition="start"
              type="submit"
              fullWidth
              size="large"
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                '&.Mui-disabled': { color: 'white', backgroundColor: '#5a5a5a' },
              }}
            >
              <span>Valider</span>
            </LoadingButton>
          </Box>
        </Box>
      </Box>
      {/* <Copyright sx={{ mt: 5 }} /> */}
    </Container>
    // </ThemeProvider>
  )
}
